/*=========================================================================================
  File Name: moduleTodoGetters.js
  Description: Map Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	// getTodosBySection: state => (sectionId) => state.todoArray.filter((task) => task.sectionId == sectionId),
};
